import { createFileRoute, redirect } from "@tanstack/react-router";
import { ExchangeLayoutComponent } from "./-components/exchange-layout";
import { hasRole, canAdminRead } from "@/lib/auth";

export const Route = createFileRoute("/(app)/_main-layout/_exchange/exchange")({
  component: ExchangeLayoutComponent,
  beforeLoad: async ({ context, location }) => {
    if (
      !hasRole("INITIATE_FX", context.authorities) &&
      !canAdminRead(context.authorities) &&
      !(
        location.pathname === "/exchange/mcp-setup" &&
        hasRole("EDIT_SETTINGS", context.authorities)
      ) &&
      location.pathname !== "/exchange"
    ) {
      throw redirect({ to: "/" });
    }
  },
});
